<template>
  <div class="container-fluid main-content">
    <span id="studentIndex" class="clickable" v-for='(char, index) in "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("")' v-bind:key="index" @click="scrollToStudents(char)"> {{char}} </span>
    <div v-if="studentList" class="row mt-4">
      <div class="col-6 offset-3">
      <ul class="list-group">
        <li class="list-group-item" v-for='(student, index) in studentList.studentArray' v-bind:key="index">
          <router-link v-bind:id='index' :to="{name: 'studentHistory', params: {id: studentList.idArray[index]}}">
            {{student}}
          </router-link>
        </li> 
      </ul>
      </div>
 
    </div>
  </div>
</template>

<script>
import { db } from '@/main.js'

export default {
    name: "AllStudents",
    data () {
      return {
        students : []
      }
    },
    computed: {
      studentList: function() {return this.students[0]}
    },
    methods: {
      scrollToStudents: function (char) {
        var sArray = this.studentList.studentArray
        var i = sArray.findIndex(el => {var x = el.split(' '); return x[x.length-1][0] === char})
        if (i !== -1) {
          var el = document.getElementById(i.toString())
          el.scrollIntoView({behavior: 'smooth'}) 
        }
      }
    },
    firestore () {
        return {
            students: db.collection('index').where("org", "==", this.$root.sharedState.org)
        }
    },
}
</script>
